import { GetBrandInfoRequest } from "../utils";
import axiosClient from "../../../../system/helpers/axiosConfig";

export const getBrandInfo = (params: GetBrandInfoRequest) => {
  return axiosClient
    .get(`/api/admin/brands/edit`, { params })
    .then((r) => r.data);
};
